import { createAttributeComponent } from '@coltorapps/builder-react'

import { widthAttribute } from './definition'

export const WidthAttribute = createAttributeComponent(
  widthAttribute,
  function WidthAttribute(props) {
    return null
  }
)
